import { pageNo,groupEndPoints} from '../../config';
import {getQueryStringFrmObject,redirectPage} from '@iso/lib/helpers/utility';
import { getCookie } from '@iso/lib/helpers/session';



class groupsApi {

  /******************************** Start of user read list ****************************/
  read = async (editInfo) => {
    console.log('-------AMIT---------------',editInfo)
    let itemUrl;
    itemUrl =groupEndPoints.read+'?pageNo='+editInfo.page+'&per_page='+pageNo;
   
    if(editInfo.info){
      var queryString = getQueryStringFrmObject(editInfo);
      itemUrl =itemUrl+'&'+queryString;
    }
    console.log('-------AMIT---------------',itemUrl)
    return await fetch(itemUrl, {
      method: 'get',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        authorization:getCookie('id_token') ? getCookie('id_token') : "",
      },
    })
    .then(function (response) {
   //   alert(response.status);
      if(response.status >=400){
        if(response.status===404){
          redirectPage("/404");
        }else{
          redirectPage("/500");
        }
    }
      return response.json();
    })
    .then(res => {
      return res;
    })
    .catch(error => ({ error }));
  };
  /******************************** End of user read list ****************************/

  /********************************Start findById**********************************/
  findById = async (fetchById) => {
    console.log("fetch type id ",fetchById);
    const fetchListUrl=groupEndPoints.findById+'/'+fetchById
    console.log('-------AMIT---------------',fetchListUrl)

    return await fetch(fetchListUrl, {
      method: 'get',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        authorization:getCookie('id_token') ? getCookie('id_token') : "",
      },
    })
      //.then(response => response.json())
      .then(function (response) {
        //   alert(response.status);
           if(response.status >=400){
             if(response.status===404){
               redirectPage("/404");
             }else{
               redirectPage("/500");
             }
         }
           return response.json();
         })
      .then(res => {
         return res;
      })
      .catch(error => ({ error }));
    };
  
    /*******************************End findById*************************************/

}

export default new groupsApi();
